import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Fade in effect
    const timer = setTimeout(() => setIsVisible(true), 500);
    return () => clearTimeout(timer);
  }, []);

  const toggleLanguage = () => {
    const newLang = i18n.language.startsWith('fr') ? 'en' : 'fr';
    i18n.changeLanguage(newLang);
  };

  return (
    <button
      className={`floating-lang-switcher ${isVisible ? 'visible' : ''}`}
      onClick={toggleLanguage}
      aria-label="Toggle Language"
      title={i18n.language.startsWith('fr') ? 'Switch to English' : 'Passer en Français'}
    >
      <Globe size={24} className="globe-icon" />
      <span className="lang-text">{i18n.language.startsWith('fr') ? 'EN' : 'FR'}</span>
    </button>
  );
};

export default LanguageSwitcher;
